import { isEmptyScObj } from "../../utils/siteUtils";
import { dictTypes } from "../../utils/lynkco-constants";
import Heading from "../../elements/heading";
import BodyText from "../../elements/body-text";
import React, { useState, useEffect } from "react";
import Dropdown from "../../elements/dropdown";
import PrimaryButton from "../../elements/primary-button";
import { selectUserState } from "../../selectors/application";
import { connect } from "react-redux";
import api from "../../utils/api";
import { getUserInfo } from "../../services/userService";
import { setUserInfoAction } from "../../redux/actions";
import { getLang } from "../../utils/processesOrderDetails";

function AccountPreferredSetting(props) {
  if (isEmptyScObj(props)) {
    return null;
  } else {
    return <AccountPreferredSettingMain {...props} />;
  }
}
function AccountPreferredSettingMain(props) {
  const [serverError, setServerError] = useState(null);
  /** Language */
  const [languageSelected, setLanguageSelectedEntered] = useState(null);
  const [changeLanguageButtonIsDisabled, setChangeLanguageButtonIsDisabled] = useState(true);
  const [languangeOptionsRes, setLanguangeOptionsRes] = useState([]);

  const onLanguageChanged = option => {
    setLanguageSelectedEntered(option);
    setChangeLanguageButtonIsDisabled(false);
  };
  const {
    fields: {
      contentHeadingType,
      contentHeadingBody,
      contentBody,
      countryLabel,
      languageLabel,
      saveFailedMessage,
      saveSuccessMessage,
      savebutton,
      languageList,
      countryList
      // languangeOptions,
      // button
    },
    lang,
    user,
    setUserInfo
  } = props;
  useEffect(() => {
    getDate();
  }, []);
  const getDate = async () => {
    let LanguangeOptions = [];
    let languages = await api.country.language(null, {
      dtyCodes: [dictTypes.language],
      countryId: user?.preferredCountryId
    });
    languages = languages?.obj?.LANGUAGE || [];
    languages.forEach(item => {
      if (item.languages[getLang(lang)]) {
        LanguangeOptions.push({
          code: item.languages[getLang(lang)]?.dicCode,
          value: item.languages[getLang(lang)]?.dicDesc
        });
      }
    });
    setLanguangeOptionsRes(LanguangeOptions);
  };
  const selectLanguange = languangeOptionsRes?.filter(item => item?.code.toLowerCase() === user?.preferredLanguage?.toLowerCase())[0],
    button = {
      ...savebutton?.fields,
      buttonText: savebutton?.fields?.buttonText?.value,
      isDisabled: changeLanguageButtonIsDisabled
    },
    country = {
      label: countryLabel.value,
      value: countryList?.fields?.items.filter(item => item?.fields?.phrase?.value.toLowerCase() === user?.preferredCountryCode?.toLowerCase()).length ? user?.preferredCountryName : "Global"
    },
    languageFixed =
      languangeOptionsRes.length > 1
        ? null
        : {
            label: languageLabel.value,
            value: selectLanguange?.value || languageList?.fields?.items.filter(item => item?.fields?.phrase?.value.toLowerCase() === user?.preferredLanguage?.toLowerCase())[0]?.fields?.key?.value
          },
    languangeOptions = {
      options: languangeOptionsRes,
      placeholder: languageLabel.value,
      selectedOption: selectLanguange
    };
  const onSubmitLanguageChange = async evt => {
    try {
      await api.user.update(null, {
        ...user,
        preferredLanguage: languageSelected.code
      });
      const userNew = await getUserInfo();
      setUserInfo(userNew);
      setServerError(saveSuccessMessage?.value);
    } catch (ex) {
      setServerError(saveFailedMessage.value);
    }
    console.log("language updated subitted data: ", languageSelected);
    setChangeLanguageButtonIsDisabled(true);
  };
  return (
    <div className="section">
      {contentHeadingType && <Heading type={contentHeadingType} typographyClass="type-h3" html={contentHeadingBody} />}
      {contentBody && <BodyText html={contentBody.value} className="form-section-builder-section-body" />}
      {country && (
        <div className="static-row">
          <div className="label">{country.label}</div>
          <div className="value">{country.value}</div>
        </div>
      )}
      {languageFixed && (
        <div className="static-row">
          <div className="label">{languageFixed.label}</div>
          <div className="value">{languageFixed.value}</div>
        </div>
      )}
      {languangeOptions && languangeOptions?.options?.length > 1 && (
        <React.Fragment>
          <Dropdown
            {...{
              ...languangeOptions,
              onChange: value => {
                onLanguageChanged(value);
              }
            }}
          />
          {serverError && <BodyText className="failed-message" html={serverError} />}
          <PrimaryButton
            {...{
              ...button,
              callback: event => onSubmitLanguageChange(event)
            }}
          />
        </React.Fragment>
      )}
    </div>
  );
}

const mapStateToProps = state => ({
  user: selectUserState(state)
});
const mapDispatchToProps = dispatch => ({
  setUserInfo: data => dispatch(setUserInfoAction(data))
});
export default connect(mapStateToProps, mapDispatchToProps)(AccountPreferredSetting);
